import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterTariffe'
})
export class MultiFilterPipe implements PipeTransform {
  transform(items: any, a: string, b: string, c: string): any {
    if (items && items.length){
        return items.filter(item =>{
            if (a&& item.attivita.id.toLowerCase().indexOf(a.toString().toLowerCase()) === -1){
                return false;
            }
            if (b && item.grado.id.toLowerCase().indexOf(b.toString().toLowerCase()) === -1){
                return false;
            }
            if (c&& item.nominativoLegale.toLowerCase().indexOf(c.toLowerCase()) === -1){
                return false;
            }
            return true;
       })
    }
    else{
        return items;
    }
    }
}
